import type { RuleBuilderConfig } from '@packages/ui/patterns/CriteriaRuleBuilder';
import taxUdcConfig from './configs/tax-udc.json';

const CONFIG_BY_MODULE: Record<string, RuleBuilderConfig> = {
  'module://shared/rule-builder/configs/tax-udc': taxUdcConfig as RuleBuilderConfig,
  'shared/rule-builder/configs/tax-udc': taxUdcConfig as RuleBuilderConfig,
};

export function loadRuleBuilderConfig(configModule: string): RuleBuilderConfig {
  const config = CONFIG_BY_MODULE[configModule];
  if (!config) {
    throw new Error(`[rule-builder] Unknown configModule: ${configModule}`);
  }
  return config;
}
